// components/DefaultSEO.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
const homeUrl = process.env.REACT_APP_HOME_URL;
const DefaultSEO = ({ title, description }) => {
  return (
    <Helmet>
      <meta name="robots" content="index, follow" />
      <title>{title || 'Crypto News & Guides - Default Title'}</title>
      <meta
        name="description"
        content={description || 'Your trusted source for crypto guides, news, and trends.'}
      />      <link rel="canonical" href={window.location.href.startsWith('http') ? window.location.href : `${homeUrl}${window.location.pathname}`} />
    </Helmet>
  );
};

export default DefaultSEO;
